export default __webpack_public_path__ + "virus.309f8278a4d02008bdafe9da2e8fecc4.svg";